import React from "react";

const Notification = ({ data }) => {
  return (
    <div>
      <div className="container">
        <div className="row location">
          <div
            // className="col-10 alert alert-success mt-3 text-center"
            className="col-12 alert alert-success mt-3 text-center"
            role="alert"
          >
            {data}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
